import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/affirmationProgram/importer/affirmationProgramImporterActions';

export default importerReducers(actions);
